'use client';

import {
	createContext,
	type ReactNode,
	useContext,
	useEffect,
	useState
} from 'react';

const ViewportSizeContext = createContext({
	isMobile: false,
	isCompact: false,
	viewportHeight: 800
});

export const ViewportSizeProvider = ({ children }: { children: ReactNode }) => {
	// SSR-safe defaults. Real values are filled in on the client in useEffect.
	// Children always render so the page is crawlable and content is in the SSR HTML.
	const [isMobile, setIsMobile] = useState(false);
	const [isCompact, setIsCompact] = useState(false);
	const [viewportHeight, setViewportHeight] = useState(800);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
			setIsCompact(window.innerWidth < 936);
			setViewportHeight(window.innerHeight);
		};
		handleResize();
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<ViewportSizeContext.Provider value={{ isMobile, isCompact, viewportHeight }}>
			{children}
		</ViewportSizeContext.Provider>
	);
};

export const useViewportSize = () => {
	const context = useContext(ViewportSizeContext);

	return {
		isMobile: context.isMobile,
		isDesktop: !context.isMobile,
		isCompact: context.isCompact,
		viewportHeight: context.viewportHeight
	};
};
